import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
Wrapper.displayName = 'Wrapper';
